import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    boxShadow: 'none',
    border: '1px solid #ced4da',
    borderRadius: '0px',
    width:'250px',
    float:'right'
  },
  input: {
    marginLeft: 8,
    flex: 1,
  },
  button: {
    borderRadius: 0,
    boxShadow: 'none',
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
});

class CustomizedSearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keyWords: ''
    }
  }
  handleChange(event) {
    this.setState({
      keyWords: event.target.value
    });
  }

  handleClick() {
    this.props.onClick(this.state.keyWords);
  }

  render() {
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
        <InputBase
          className={classes.input}
          placeholder="Search…"
          inputProps={{ 'aria-label': 'Search…' }}
          onChange={this.handleChange.bind(this)}
          value={this.state.keyWords}
          endAdornment={
            <InputAdornment position="end">
              {this.state.keyWords.length > 0 ?
                <CloseIcon
                  color="disabled"
                  style={{ cursor: 'pointer',width:'18px',height:'18px' }}
                  onClick={() => { this.setState({ keyWords: '' }) }}
                /> : ''}
            </InputAdornment>
          }
        />
        <Button color="primary" variant="contained" size="small" aria-label="search" className={classes.button} onClick={this.handleClick.bind(this)}>
          <SearchIcon />
        </Button>
      </Paper>
    );
  }
}
CustomizedSearchInput.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default withStyles(styles)(CustomizedSearchInput);
